import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@querodelivery/uni-react';
import { colors } from '@/Themes/Colors';
import style from './confirm-activate-post-paid-modal.module.scss';
import { usePutPostPaid } from '@/_features/places/api/put-post-paid';
import { queryClient } from '@/_config/lib/react-query/query-client';
import { GET_PLACE_ID } from '@/_features/places/api/constants';
import { Modal } from '@/_components/modal/modal';
import { useGetPlaceById } from '@/_features/places/api/get-place-by-id';
import { formatCurrency } from '@/Utils/FnUtils';

interface ConfirmActivatePostPaidModalProps {
  open: boolean;
  onClose: () => void;
  placeId: string;
}

export const ConfirmActivatePostPaidModal = ({
  open,
  onClose,
  placeId,
}: ConfirmActivatePostPaidModalProps) => {
  const { mutate: updatePostPaid, isLoading } = usePutPostPaid();

  const { data: place } = useGetPlaceById(
    {
      placeId: placeId || '',
    },
    {
      enabled: open && !!placeId,
    },
  );

  const currentLimit = place?.postPaid?.postPaidLimit || 0;
  const currentLimitFormatted = formatCurrency(currentLimit);

  const handleConfirm = () => {
    updatePostPaid(
      {
        placeId,
        statusPostPaid: 'ACTIVE',
        postPaidLimit: currentLimit,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([GET_PLACE_ID, { placeId }]);
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      bodyClassName={style.bodyContainer}
      noBorder
      onClose={onClose}
      open={open}
      width={500}
    >
      <FontAwesomeIcon icon={faBell} color={colors.gray60} size="4x" />
      <span className={style.title}>
        Você está ativando o pós pago para este parceiro.
      </span>
      <span className={style.description}>
        {`O parceiro ${place?.nomeExibicao} já possui um limite de crédito mensal configurado de ${currentLimitFormatted}. Deseja ativar o pós pago com esse limite?`}
      </span>
      <div className={style.buttons}>
        <Button
          className={style.button}
          onClick={onClose}
          disabled={isLoading}
          variant="outline"
          size="lg"
        >
          Cancelar
        </Button>
        <Button
          className={style.button}
          onClick={handleConfirm}
          disabled={isLoading}
          variant="primary"
          size="lg"
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
